import { ApiError } from '@collector/sportsapi-client-legacy'

/**
 * Custom error class to preserve data from RabbitMQ error messages
 */
export class RabbitMQError extends Error {
  public readonly code: ApiError['code']

  constructor(message: string, code: number) {
    super(message)
    this.name = 'RabbitMQError'
    this.code = code
  }
}
